import React from "react";

function LinearSend({ viewBox = "0 0 40 48", className = "", opacity = "0.5", ...rest }) {
  return (
    <svg data-testid="linear-send-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="48" fill="none" viewBox={viewBox} className={className} {...rest}>
      <g opacity={opacity}>
        <g>
          <path
            stroke="url(#paint0_linear_10454_215)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
            d="M15.62 21.265l-2.354-6.388 19.018 9.265-19.018 9.266 3.413-9.266h5.852"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_10454_215" x1="18.142" x2="32.281" y1="10" y2="24.464" gradientUnits="userSpaceOnUse">
          <stop stopColor="#26BBED"></stop>
          <stop offset="1" stopColor="#847DF4"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default LinearSend;
